import { TenantSpec } from '../types';
import { clustersFromId } from './kaapTenants';

/**
 * Builds the pre-filled scaffolder form data for the edit-tenant template from
 * the live KaaP API tenant plus the catalog entity's `spec.tenant`.
 */
export const buildFormData = (tenant?: TenantSpec) => {
  if (!tenant) {
    return {};
  }

  const quota = tenant?.tenantResourceQuota ?? ({} as any);

  return {
    // All values are nested under the single `tenant` object field
    // (`ui:field: KaapTenantForm`) that the edit template declares.
    tenant: {
      tenantName: tenant?.name ?? '',
      stage: tenant?.stage ?? tenant.stage ?? '',
      tier: tenant?.tier ?? tenant.tier ?? '',
      tenantId: tenant?.id ?? tenant.id ?? '',
      ownerObjectId: tenant?.ownerObjectId ?? tenant.ownerObjectId ?? '',
      clusterSelection: {
        clusters:
          tenant.clusters ??
          clustersFromId(tenant.clusterId, tenant.nodeGroups),
        tier: tenant?.tier ?? tenant.tier ?? '',
        nodeGroups: tenant?.nodeGroups ?? tenant.nodeGroups ?? [],
      },
      application: tenant?.applicationId ?? tenant.applicationId ?? '',
      cabInform: tenant.cabInform ?? false,
      securityObjectIds:
        tenant?.securityObjectIds ?? tenant.securityObjectIds ?? [],
      pimEnabled: tenant?.pimEnabled ?? false,
      pimGroupId: tenant?.pimGroupId ?? null,
      slackChannel: tenant?.slackChannel ?? tenant.slackChannel ?? '',
      namespaceQuota: String(
        tenant?.namespaceQuota ?? tenant.namespaceQuota ?? 3,
      ),
      cpuRequest: String(quota.cpuRequest ?? 4000),
      cpuLimit: String(quota.cpuLimit ?? 4000),
      memoryRequest: String(quota.memoryRequest ?? 8192),
      memoryLimit: String(quota.memoryLimit ?? 8192),
      gitopsConfig: {
        enabled: !!tenant?.argocdProject,
        gitRepos: tenant?.argocdProject?.repositories ?? [],
        rootPath: tenant?.argocdProject?.rootPath ?? '',
        helmRepos: tenant?.argocdProject?.helmRepositories ?? [],
      },
    },
  };
};
